import { selectProductsByType } from '../selectors';
export const selectCartWidgetSuggestions = (state, cartId) => {
  const suggestions = state.cart.widgetSuggestions[cartId];
  if (!suggestions || !suggestions.some(suggestion => suggestion.product_type === 'domain')) return suggestions;
  const domains = selectProductsByType(state, {
    productType: 'domain'
  });
  return suggestions.filter(suggestion => {
    if (suggestion.product_type !== 'domain') return true;
    return !domains.some(domain => domain.payload.fqdn === suggestion.payload.fqdn);
  });
};